import ReactDOM, { hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { FormProvider } from "./Context/FormContext";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <FormProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </FormProvider>
  </BrowserRouter>
);
// hydrateRoot(
//   document.getElementById("root"),
//   <BrowserRouter>
//     <FormProvider>
//       <HelmetProvider>
//         <App />
//       </HelmetProvider>
//     </FormProvider>
//   </BrowserRouter>
// );

reportWebVitals();
